
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/architecture-modernization",
      function () {
        return require("private-next-pages/books/architecture-modernization.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/architecture-modernization"])
      });
    }
  